<template>
<div>
    <domain-status-list></domain-status-list>
</div>
</template>

  
<script>
export default {}
</script>
